export const getUserInitials = (name: string | undefined) => {
  const defaultInitials = "TP";
  if (name) {
    const firstInitial = name.split(" ")[0]?.charAt(0);
    const secondInitial = name.split(" ")[1]?.charAt(0);
    if (firstInitial && secondInitial) return `${firstInitial}${secondInitial}`;
    if (firstInitial) return `${firstInitial}`;
    if (secondInitial) return `${secondInitial}`;
    return defaultInitials;
  } else {
    return defaultInitials;
  }
};

export const getCapitalizedUserInitials = (name: string | undefined) => {
  return getUserInitials(name).toUpperCase();
};
